// @ts-nocheck — migrated from JS; reactstrap / react-select / layout prop friction.
import React, { Fragment } from "react";
import { Colxx, Separator } from "Components/CustomBootstrap";
import BreadcrumbContainer from "Components/BreadcrumbContainer";
import IntlMessages from "Util/IntlMessages";
import { Row, Card, CardBody, CardTitle } from "reactstrap";
import ReactSiemaCarousel from "Components/ReactSiema/ReactSiemaCarousel";
import Fullscreen from "Components/Fullscreen";

function carousels() {
    return (
      <Fragment>
        <Row>
          <Colxx xxs="12">
            <BreadcrumbContainer
              heading={<IntlMessages id="menu.carousel" />}
            />
            <div className="float-right">
              <Fullscreen />
            </div>
            <Separator className="mb-5" />
          </Colxx>
        </Row>

        {/* Single Carousel */}

        <Colxx xxs="12">
          <Card>
            <CardTitle className="mt-3 ml-3">
              <IntlMessages id="carousel.wide" />
            </CardTitle>
          </Card>
        </Colxx>

        <Colxx xxs="12" className="pl-0 pr-0 mb-5">
          <ReactSiemaCarousel
            perPage={{
              0: 1
            }}
            loop={false}
          >
            <div className="pr-3 pl-3">
              <Card>
                <div className="position-relative">
                  <img
                    className="card-img-left h-250"
                    src="/assets/img/reactjs.png"
                    alt="react image"
                  />
                </div>

                <div>
                  <CardBody>
                    <span className="badge badge-pill radius-0px badge-theme-1 position-absolute">
                      Just Posted
                    </span>
                    <h6 className="mt-4">
                      Top 10 programming languages in 2019
                    </h6>

                    <footer>
                      <p className="text-muted text-small mb-0 font-weight-light">
                        10.03.2019
                      </p>
                    </footer>
                  </CardBody>
                </div>
              </Card>
            </div>

            <div className="pr-3 pl-3">
              <Card>
                <div className="position-relative">
                  <img
                    className="card-img-left h-250"
                    src="/assets/img/programming.jpg"
                    alt="programming"
                  />
                </div>

                <div>
                  <CardBody>
                    <span className="badge badge-pill radius-0px badge-theme-1 position-absolute">
                      1 Hour Ago
                    </span>
                    <h6 className="mt-4">
                      New programming languages keep chipping away at the old
                    </h6>

                    <footer>
                      <p className="text-muted text-small mb-0 font-weight-light">
                        10.03.2019
                      </p>
                    </footer>
                  </CardBody>
                </div>
              </Card>
            </div>
          </ReactSiemaCarousel>
        </Colxx>

        {/* Single Carousel Ends Here */}

        {/* Post Carousel Starts Here */}
        <Row>
          <Colxx xxs="12">
            <Card>
              <CardTitle className="ml-3 mt-3">
                <IntlMessages id="carousel.post" />
              </CardTitle>
            </Card>
          </Colxx>
          <Colxx xxs="12" className="pl-0 pr-0 mb-5">
            <ReactSiemaCarousel
              perPage={{
                0: 1,
                1000: 2,
                1400: 3
              }}
              loop={false}
            >
              <div className="pr-3 pl-3">
                <Card>
                  <div className="position-relative">
                    <img
                      className="card-img-left h-250"
                      src="/assets/img/reactjs.png"
                      alt="react image"
                    />
                  </div>

                  <div>
                    <CardBody>
                      <span className="badge badge-pill radius-0px badge-theme-1 position-absolute">
                        Just Posted
                      </span>
                      <h6 className="mt-4">
                        Top 10 programming languages in 2019
                      </h6>

                      <footer>
                        <p className="text-muted text-small mb-0 font-weight-light">
                          10.03.2019
                        </p>
                      </footer>
                    </CardBody>
                  </div>
                </Card>
              </div>

              <div className="pr-3 pl-3">
                <Card>
                  <div className="position-relative">
                    <img
                      className="card-img-left h-250"
                      src="/assets/img/programming.jpg"
                      alt="programming"
                    />
                  </div>

                  <div>
                    <CardBody>
                      <span className="badge badge-pill radius-0px badge-theme-1 position-absolute">
                        1 Hour Ago
                      </span>
                      <h6 className="mt-4">
                        New programming languages keep chipping away at the old
                      </h6>

                      <footer>
                        <p className="text-muted text-small mb-0 font-weight-light">
                          10.03.2019
                        </p>
                      </footer>
                    </CardBody>
                  </div>
                </Card>
              </div>

              <div className="pr-3 pl-3">
                <Card>
                  <div className="position-relative">
                    <img
                      className="card-img-left h-250"
                      src="/assets/img/email.jpeg"
                      alt="email"
                    />
                  </div>

                  <div>
                    <CardBody>
                      <span className="badge badge-pill badge-theme-1 position-absolute radius-0px">
                        Posted Yesterday
                      </span>
                      <h6 className="mt-4">
                        An email marketing company left 809 million records
                      </h6>

                      <footer>
                        <p className="text-muted text-small mb-0 font-weight-light">
                          09.03.2019
                        </p>
                      </footer>
                    </CardBody>
                  </div>
                </Card>
              </div>
            </ReactSiemaCarousel>
          </Colxx>

          <Colxx xxs="12">
            <Card>
              <CardTitle className="ml-3 mt-3">
                <IntlMessages id="carousel.team" />
              </CardTitle>
            </Card>
          </Colxx>

          {/* Post Carousel Ends Here */}

          <Colxx xxs="12" className="pl-0 pr-0 mb-4">
            <ReactSiemaCarousel
              perPage={{
                0: 1,
                480: 2,
                800: 3,
                1200: 4
              }}
              controls={false}
              loop={false}
            >
              <div className="pr-3 pl-3">
                <div className="position-relative">
                  <img
                    className="card-img-top user-profile-images-c"
                    src="/assets/img/p1.png"
                    alt="user"
                  />
                </div>
                <Card>
                  <CardBody className="text-center my-3">
                    <h6 className="mb-4">Jane Silva</h6>

                    <footer>
                      <p className="text-muted text-small mb-0 font-weight-light">
                        UX/UI Developer
                      </p>
                    </footer>
                  </CardBody>
                </Card>
              </div>
              <div className="pr-3 pl-3">
                <div className="position-relative">
                  <img
                    className="card-img-top user-profile-images-c"
                    src="/assets/img/p2.png"
                    alt="user"
                  />
                </div>
                <Card>
                  <CardBody className="text-center my-3">
                    <h6 className="mb-4">Jessie Wells</h6>

                    <footer>
                      <p className="text-muted text-small mb-0 font-weight-light">
                        ReactJS Developer
                      </p>
                    </footer>
                  </CardBody>
                </Card>
              </div>
              <div className="pr-3 pl-3">
                <div className="position-relative">
                  <img
                    className="card-img-top user-profile-images-c"
                    src="/assets/img/p3.png"
                    alt="user"
                  />
                </div>
                <Card>
                  <CardBody className="text-center my-3">
                    <h6 className="mb-4">Lily Doe</h6>

                    <footer>
                      <p className="text-muted text-small mb-0 font-weight-light">
                        Fullstack Developer
                      </p>
                    </footer>
                  </CardBody>
                </Card>
              </div>
              <div className="pr-3 pl-3">
                <div className="position-relative">
                  <img
                    className="card-img-top user-profile-images-c"
                    src="/assets/img/p4.png"
                    alt="user"
                  />
                </div>
                <Card>
                  <CardBody className="text-center my-3">
                    <h6 className="mb-4">Noah J</h6>

                    <footer>
                      <p className="text-muted text-small mb-0 font-weight-light">
                        NodeJS Developer
                      </p>
                    </footer>
                  </CardBody>
                </Card>
              </div>
              <div className="pr-3 pl-3">
                <div className="position-relative">
                  <img
                    className="card-img-top user-profile-images-c"
                    src="/assets/img/p6.png"
                    alt="user"
                  />
                </div>
                <Card>
                  <CardBody className="text-center my-3">
                    <h6 className="mb-4">Isabella A</h6>

                    <footer>
                      <p className="text-muted text-small mb-0 font-weight-light">
                        PHP Developer
                      </p>
                    </footer>
                  </CardBody>
                </Card>
              </div>
              <div className="pr-3 pl-3">
                <div className="position-relative">
                  <img
                    className="card-img-top user-profile-images-c"
                    src="/assets/img/p1.png"
                    alt="user"
                  />
                </div>
                <Card>
                  <CardBody className="text-center my-3">
                    <h6 className="mb-4">Grace M</h6>

                    <footer>
                      <p className="text-muted text-small mb-0 font-weight-light">
                        Python Developer
                      </p>
                    </footer>
                  </CardBody>
                </Card>
              </div>
            </ReactSiemaCarousel>
          </Colxx>
        </Row>
      </Fragment>
    );
}

export default carousels;
